import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter, UrlSerializer } from "@angular/router";
import { AppComponent } from "./app/app.component";
import { Routes } from "./app/Routes"; // Adjust the path as needed
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import {
  GoogleLoginProvider, SOCIAL_AUTH_CONFIG,
  SocialAuthServiceConfig,
} from "@abacritt/angularx-social-login";
import { authGuard } from "./app/auth.guard";
import { JwtInterceptor } from "./app/interceptors/JwtInterceptor";
import { LowerCaseUrlSerializer } from "./app/LowerCaseUrlSerializer";
import { CSP_NONCE } from "@angular/core";
import { ErrorInterceptor } from "./app/interceptors/ErrorInterceptor";

bootstrapApplication(AppComponent, {
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    provideRouter(Routes),
    provideAnimations(),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    authGuard,
    { provide: MAT_DATE_LOCALE, useValue: "da-DK" },
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              "771594468111-up4gc4cqovqtit4fpdkptq0vehufvso3.apps.googleusercontent.com",
              { oneTapEnabled: false }
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      provide: CSP_NONCE,
      useValue:
        "twqnC6ypf651nfCdTYpPWjKh8zT7EbEjBOueaZF8jdhbbDVkU9qK1y5Y41tyVdd",
    },
  ],
}).catch((err) => console.error(err));
